var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGotoos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "180px",
    height: "121px",
    viewBox: "0 0 180 121",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-25.4%",
    y: "-46.5%",
    width: "150.8%",
    height: "193.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.404365172   0 0 0 0 0.939651268   0 0 0 0 0.935800289  0 0 0 0.238690997 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.2101251%",
    y1: "35.0857988%",
    x2: "89.9439995%",
    y2: "64.9142012%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77FFFC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BB6FF",
    offset: "54.8268138%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B4FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.2101251%",
    y1: "9.7141866%",
    x2: "89.9439995%",
    y2: "90.2858134%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29B5B2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0081FF",
    offset: "53.8051792%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2472BB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0405_Renew-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buy-Fish/Logout",
    transform: "translate(-1223.000000, -905.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-6",
    filter: "url(#filter-1)",
    transform: "translate(1248.000000, 930.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Combined-Shape",
    stroke: "url(#linearGradient-2)",
    strokeWidth: 4,
    x: 0,
    y: 0,
    width: 130,
    height: 71,
    rx: 35.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7056,52.9999 C62.1145,52.9999 59.5044,52.9999 56.9132,52.9999 C54.7381,52.9999 52.6765,52.5475 50.8797,51.3224 C47.7401,49.2115 46.0757,46.309 46,42.5206 C46,42.1248 46.1135,41.9552 46.5485,41.9552 C49.4045,41.974 52.2604,41.9552 55.0975,41.9552 C55.4947,41.9552 55.7216,42.0306 55.7216,42.5206 C55.7027,44.4054 57.0645,45.8001 58.9559,45.8566 C60.3177,45.8943 61.6984,45.8566 63.0601,45.8755 C63.4195,45.8755 63.5141,45.7247 63.5141,45.3854 C63.4952,44.575 63.4762,43.7457 63.5141,42.9352 C63.533,42.4452 63.3438,42.2944 62.8899,42.2944 C61.8307,42.2944 60.7716,42.3133 59.7313,42.2944 C59.4098,42.2944 58.9937,42.4641 58.8046,42.1248 C58.6154,41.8044 58.9937,41.5594 59.1639,41.3144 C59.9016,40.2023 60.5824,39.0526 61.2066,37.8841 C62.2658,35.8862 62.7386,33.7565 62.436,31.4759 C62.1145,28.9503 61.3201,26.5755 60.3177,24.2384 C59.8637,23.183 59.3909,22.1463 58.8235,21.1663 C58.7478,21.0343 58.5965,20.8647 58.7478,20.6951 C58.8802,20.5631 59.0504,20.6574 59.2017,20.6951 C60.469,21.0343 61.7173,21.3736 62.9845,21.7128 C63.4952,21.8448 63.5141,21.8071 63.533,21.2793 C63.5519,20.7328 63.5897,20.1862 63.5708,19.6396 C63.533,18.7538 64.5921,17.9433 65.4054,17.9999 C66.2755,18.0564 67.032,18.7915 67.0509,19.7338 C67.0698,20.582 67.0698,21.4301 67.0509,22.2783 C67.0509,22.6364 67.1455,22.8437 67.5049,23.051 C68.3371,23.5411 68.999,24.2196 69.7178,24.8604 C71.1552,26.1609 72.4602,27.5744 73.5194,29.1953 C74.4462,30.6089 75.1649,32.1167 75.2027,33.8695 C75.2216,35.3208 74.6731,36.5648 73.9355,37.7333 C72.9898,39.2411 71.8361,40.5793 70.531,41.8044 C70.1717,42.1436 69.7934,42.351 69.2827,42.3133 C68.7153,42.2756 68.1479,42.3133 67.5805,42.2944 C67.2211,42.2944 67.0509,42.4075 67.0509,42.7845 C67.0698,43.6515 67.0698,44.5184 67.0509,45.3666 C67.0509,45.7435 67.2022,45.8566 67.5616,45.8566 C68.6018,45.8378 69.6421,45.8755 70.6823,45.8566 C71.7415,45.8378 72.5548,45.2723 73.2735,44.5561 C73.614,44.2169 73.9922,43.8965 74.3138,43.5195 C74.7299,43.0106 75.2595,42.7656 75.8647,42.596 C78.134,41.9552 80.385,41.2767 82.655,40.6358 C83.26,40.4662 83.865,40.3154 84.47,40.1458 C84.792,40.0516 84.962,40.2023 84.981,40.5039 C85,41.0882 85,41.6725 84.981,42.2379 C84.981,42.6148 84.641,42.7091 84.376,42.8222 C83.638,43.1614 82.957,43.5572 82.295,44.0096 C81.425,44.6127 80.839,45.4608 80.272,46.3278 C79.137,48.0995 78.134,49.9842 76.5645,51.4544 C75.4864,52.4721 74.2003,52.981 72.725,52.9622 C70.0582,52.9999 67.3725,52.9999 64.7056,52.9999 Z",
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotoos);
export default __webpack_public_path__ + "static/media/gotoos.e74121553dd984248212074fd5bfd23e.svg";
export { ForwardRef as ReactComponent };